var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bs",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M21.858,0H0V13.62L4.5,27.453l27.548-.017L9.765,43.63,18.29,69.84,0,56.558V512H450.359l-21.591-15.678,27.548-.018,8.508-26.21,8.525,26.21,27.548-.017L479.275,512H512V490.143ZM20.612,116.742,29.1,90.549,6.8,74.358,34.35,74.34l8.508-26.21,8.525,26.21,27.548-.017L56.649,90.515l8.526,26.21-22.3-16.193ZM67.5,163.627l8.491-26.193-22.3-16.192,27.548-.018,8.508-26.209,8.525,26.209,27.548-.017L103.535,137.4l8.526,26.21-22.3-16.193Zm46.885,46.885,8.491-26.192-22.3-16.193,27.548-.018,8.508-26.21,8.525,26.21,27.548-.017L150.42,184.285l8.525,26.21-22.3-16.193ZM161.267,257.4l8.49-26.193-22.3-16.193,27.548-.018,8.508-26.21,8.525,26.21,27.548-.017-22.282,16.193,8.526,26.21-22.3-16.193Zm46.884,46.885,8.491-26.193-22.3-16.193,27.548-.018,8.508-26.209,8.525,26.209,27.548-.017L244.19,278.054l8.526,26.21-22.3-16.193Zm46.886,46.884,8.491-26.192-22.3-16.193,27.548-.018,8.508-26.21,8.525,26.21,27.548-.017-22.282,16.193,8.525,26.21-22.3-16.193Zm46.885,46.886,8.49-26.193-22.3-16.193,27.548-.018,8.508-26.21,8.525,26.21,27.548-.017L337.96,371.824l8.526,26.21-22.3-16.193Zm46.885,46.885,8.491-26.193L335,402.551l27.548-.018,8.508-26.209,8.525,26.209,27.548-.017-22.282,16.193,8.526,26.21-22.3-16.193ZM440.255,491.8l-22.3-16.193-22.265,16.209,8.491-26.192-22.3-16.193,27.548-.018,8.508-26.21,8.525,26.21,27.548-.017-22.282,16.193Z",
    fill: "#0052b4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M512,0H21.858L512,490.143Z",
    fill: "#ffda44"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M9.765,43.63,32.047,27.438,4.5,27.454,0,13.621V56.558L18.291,69.84Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M56.649,90.515,78.933,74.322l-27.548.017-8.526-26.21-8.508,26.21L6.8,74.357,29.1,90.549l-8.491,26.193,22.265-16.21,22.3,16.193Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M103.535,137.4l22.282-16.193-27.548.017L89.745,95.015l-8.51,26.209-27.546.018,22.3,16.192L67.5,163.627l22.264-16.21,22.3,16.193Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M150.42,184.285,172.7,168.092l-27.548.017L136.629,141.9l-8.508,26.209-27.548.017,22.3,16.193-8.49,26.193,22.264-16.21,22.3,16.192Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M197.3,231.17l22.282-16.192-27.548.016-8.525-26.21-8.508,26.21-27.548.018,22.3,16.192-8.49,26.193,22.264-16.209,22.3,16.192Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M244.189,278.055l22.284-16.193-27.548.017L230.4,235.67l-8.508,26.209-27.547.018,22.3,16.192-8.492,26.193,22.266-16.21,22.3,16.193Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M291.075,324.94l22.282-16.193-27.547.017-8.525-26.209-8.508,26.209-27.548.018,22.3,16.192-8.49,26.192L277.3,334.957l22.3,16.193Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M337.96,371.824l22.282-16.191-27.548.017-8.525-26.21-8.508,26.21-27.548.016,22.3,16.193-8.49,26.193,22.264-16.21,22.3,16.192Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M384.845,418.71l22.282-16.192-27.548.016-8.525-26.21-8.508,26.21L335,402.552l22.3,16.192-8.491,26.193,22.265-16.21,22.3,16.192Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M426.464,449.419l-8.524-26.21-8.509,26.21-27.548.018,22.3,16.192-8.492,26.193,22.266-16.21,22.3,16.193-8.526-26.21L454.012,449.4Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M473.35,496.3,464.825,470.1,456.316,496.3l-27.547.018L450.359,512h28.916L500.9,496.287Z",
    fill: "#f0f0f0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBs);
export default __webpack_public_path__ + "static/media/bs.eddbfe376cd64b2e74c53c116153fb21.svg";
export { ForwardRef as ReactComponent };